export const TEMPLATE_VEHICLES = 'vehicles';
export const TEMPLATE_BRAND_OVERVIEW = 'brand_overview';
